// @flow

const styles = {
  processLegend: (theme) => ({
    textAlign: 'center'
  }),
  dialogContentCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    position: 'relative'
  }),
  arrowIcon: (theme) => ({
    position: 'relative',
    fontSize: 52,
    opacity: '25%'
  }),
  textField: (theme) => ({
    '& label.MuiInputLabel-shrink': {
      transform: 'translate(24px, -5px) scale(0.75)'
    }
  }),
  textFieldCaptionRight: (theme) => ({
    textAlign: 'right',
    color: theme.palette.primary.light,
    fontSize: '0.8rem'
  }),
  iconButton: (theme) => ({
    float: 'left'
  }),
  errorLabel: (theme) => ({
    marginLeft: theme.spacing(1),
    color: '#f44336 !important'
  }),
  tagCtr: (theme) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4)
  }),
  grow: (theme) => ({
    flexGrow: 1
  }),
  flexContainer: (theme) => ({
    display: 'flex',
    flexDirection: 'column'
  })
};
  
export default styles;